import { captureException, configureScope } from '@sentry/react';
import { getAppShellInfo, safeWindow } from '@sky-distribution/gp-onboarding-shared-utils';
import { maskObject } from '@sky-distribution/mask-util';
import { MaskObject } from '@sky-distribution/mask-util/lib/type';
import { isRequestError, isResponseError } from './error.type';
import { getDebugData } from './getDebugData';
import { HttpError } from './HttpError';

export const logAndThrowHttpError = <T extends unknown>(
  method: string, body?: unknown,
) => (error: unknown): { data: T } => {
    const httpError = new HttpError(method);

    if (isResponseError(error)) {
      httpError.setType('response');
      httpError.setStatus(error.response?.status);
      httpError.setHeaders(error.response?.headers);
      httpError.setResponse(error.response?.data);
    } else if (isRequestError(error)) {
      httpError.setType('noResponse');
    } else {
      httpError.setResponse(error);
    }

    configureScope((scope) => {
      scope.setTags({
        status: httpError.status,
        errorType: httpError.errorType,
      });
      scope.setContext('appState', {
        ...getDebugData(),
        pathname: String(safeWindow().location?.pathname),
      });
      scope.setContext('error', {
        method: httpError.method,
        status: httpError.status,
        requestBody: body && maskObject(body as MaskObject),
        responseBody: httpError.response,
        responseHeaders: httpError.headers,
      });
      scope.setContext('appShell', getAppShellInfo());
      scope.setFingerprint([
        '{{ default }}',
        httpError.method,
        httpError.status,
        String(safeWindow().location?.pathname),
      ]);
      captureException(httpError);
    });
    throw error;
  };
